import { render, staticRenderFns } from "./optionsReceptor.vue?vue&type=template&id=19122d0b&scoped=true"
import script from "./optionsReceptor.vue?vue&type=script&lang=js"
export * from "./optionsReceptor.vue?vue&type=script&lang=js"
import style0 from "./optionsReceptor.vue?vue&type=style&index=0&id=19122d0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19122d0b",
  null
  
)

export default component.exports